import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getAnimateActorAnimationName,
  IAnimateActor,
} from "../../../models/AnimateActor";
import Interaction from "../../../models/interactions/Interaction";
import {
  selectCachedAnimationDetails,
  setCachedAnimationDetails,
} from "../../../app/slices/AnimationsSlice";
import { selectCurrentOrganization } from "../../../app/slices/UserSlice";
import { AnimationService } from "../../../services/AnimationService";

export default function useAnimateActorAnimationDetails(
  overrideInteraction?: Interaction
) {
  const dispatch = useDispatch();
  const cached = useSelector(selectCachedAnimationDetails);
  const currentOrganization = useSelector(selectCurrentOrganization);
  const interaction = overrideInteraction as IAnimateActor | undefined;
  const animationName = getAnimateActorAnimationName(interaction?.animation);

  useEffect(() => {
    if (!animationName || !currentOrganization?.id) return;
    if (cached[animationName]) return;

    const loadAnimationDetails = async () => {
      const details = await AnimationService.GetAnimationDetails(
        currentOrganization.id,
        animationName
      );
      if (!details) return;

      dispatch(
        setCachedAnimationDetails({
          animationName,
          animationDetails: details,
        })
      );
    };

    loadAnimationDetails();
  }, [animationName, cached, currentOrganization?.id, dispatch]);
}
